import { getGeoIPCountryCode } from './_utils';

(function () {
	'use strict';

	window.FS = window.FS || {};
	window.FS.suppressLinksGeoIP = () => {
		const geoIPCode = getGeoIPCountryCode();

		var elements = Array.from(document.querySelectorAll('[data-geo-ip-suppressions-list]'));
		elements.forEach(element => {
			const geoIpList = element.dataset?.geoIpSuppressionsList?.split(',');
			if (geoIpList?.includes(geoIPCode)) {
				element.remove();
			}
		});
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', window.FS.suppressLinksGeoIP);
	} else {
		window.FS.suppressLinksGeoIP();
	}
})();
